import React from 'react';
import PropTypes from 'prop-types';
import SigninForm from './signinForm';

class SignIn extends React.Component {
    constructor(props) {
        super(props);
        this.displayName = 'SignIn';
        this.handleSignin = this.handleSignin.bind(this);
    }
    handleSignin(data) {
      if(this.props && typeof this.props.onSignin === 'function')
        this.props.onSignin(data);
    }
    render() {
        return (
          <section className="body-sign">
            <div className="center-sign">
              <a href="/" className="logo pull-left">
                <img src="assets/images/logo-default.png" height="54" alt="Hailtrace App" />
              </a>
              <div className="panel panel-sign">
                <div className="panel-title-sign mt-xl text-right">
                  <h2 className="title text-uppercase text-weight-bold m-none"><i className="fa fa-user mr-xs"></i> Sign In</h2>
                </div>
                <div className="panel-body">
                <SigninForm onSignin={this.handleSignin} />
                <p className="text-center">Don't have an account yet? <a href="/signup">Sign Up!</a></p>
                </div>
              </div>
            </div>
          </section>
        );
    }
}

export default SignIn;



// WEBPACK FOOTER //
// ./src/browser/components/sales/signin.js